export function calculateTablePage(tableDataLength) {
  return Math.floor((tableDataLength / 5) + 1);
}